import * as React from 'react';
import settingsIcon from '../assets/images/Icon-feather-settings.png';
class IconSettingClass extends React.Component {
    render() {
        return <img src={settingsIcon} alt="" />;
    }
};
export default IconSettingClass;